<template>
    <router-view />
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import '@mdi/font/css/materialdesignicons.css'

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body{
  padding:0;
  margin:0;
}
@font-face {
  font-family: 'Schneider';
  src: url('@/assets/schneider-weisse.otf.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}
</style>
